import { Component, Event, EventEmitter, h, Host, Prop, Watch } from '@stencil/core'

/**
 * ## Design System
 *
 * Para a documentação completa de design, incluindo diretrizes de uso, acessibilidade e exemplos visuais, consulte o [Design System do GovBR](https://www.gov.br/ds/components/breadcrumb?tab=designer).
 */
@Component({
  tag: 'br-crumb',
  shadow: true,
})
export class Crumb {
  /**
   * Rótulo (texto) do crumb.
   */
  @Prop({ reflect: true }) readonly label: string

  /**
   * URL ou caminho para o qual o usuário será direcionado ao clicar no crumb.
   */
  @Prop({ reflect: true }) readonly url?: string

  /**
   * Define o alvo do link quando `url` está presente. (ex: _blank, _self).
   */
  @Prop({ reflect: true }) readonly target?: string

  /**
   * Define se o crumb é o item inicial (Home).
   */
  @Prop() readonly home: boolean = false

  /**
   * Define se o crumb é a página atual ativa no breadcrumb.
   */
  @Prop() readonly active: boolean = false

  /**
   * Evento disparado quando as propriedades do crumb mudam.
   * O componente pai (br-breadcrumb) escuta este evento para se atualizar.
   */
  @Event() brCrumbPropsChange: EventEmitter<void>

  @Watch('label')
  @Watch('url')
  @Watch('target')
  @Watch('home')
  @Watch('active')
  handlePropsChange() {
    this.brCrumbPropsChange.emit()
  }

  render() {
    return (
      <Host style={{ display: 'none' }}>
        <slot></slot>
      </Host>
    )
  }
}
